import { render } from "./NedbankDepositWebsite.vue?vue&type=template&id=7a11e2ad&scoped=true"
import script from "./NedbankDepositWebsite.vue?vue&type=script&lang=js"
export * from "./NedbankDepositWebsite.vue?vue&type=script&lang=js"

import "./NedbankDepositWebsite.vue?vue&type=style&index=0&id=7a11e2ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a11e2ad"]])

export default __exports__